/**
 * Created by Languagenut on 18/04/2019.
 */

 
import React  from 'react';
import Base from './assign_library_step.js';
import ClassesStore from '../../../store/classes-store'
import Constants from '../../../constants.js';
import Translation from '../../../store/internationalization-store.js'
import HomeworkStore from '../../../store/homework-store'
import AssignmentService from '../../../services/assignments-service'

class Comfirmation extends Base.component {

    constructor(props) {
        super();
    }

    componentWillMount() {
        AssignmentService.getSingleLibraryAssignment(this.props.information.homeworkID, this.props.information.curriculumID).then(function(homework){
            this.setState({
                homework:homework,
                homeworkName:homework.title,
                tasks:homework.tasks, 
                loaded:true})
        }.bind(this));

        ClassesStore.on(Constants.GET_CLASSES_LIST,  ()=>{
            var classes = ClassesStore.list;
                var classStates = {};
                var classMine = []
                for(var idx = 0 ; idx < classes.length; idx++)
                {
                    var selected = false;
                    classStates[classes[idx].uid] = {allStudents:true , selected:selected, students:[]};

                    if (classes[idx].isMine) {
                        classMine.push(classes[idx]);
                    }
                }

                this.setState({
                    classes:classes,
                    classStates:classStates,
                    classMine:classMine
                });
        })

    }


    handleHomeworkSubmission(){
        this.convert();

        var $homeworkName = this.state.homeworkName;
        var $comment = this.state.comment;
        var $toDate = this.state.endDate;
        var $fromDate = this.state.startDate;
        var $isRepeatable = this.state.isRepeatable;
        var $overallData = HomeworkStore.getCurrentHomeworks();
        for (var i = 0; i < $overallData.length; i++) {
            $overallData[i]['data'] = undefined;
        }
        var $totalClass = [];
        var $studentsOnly = [];

        for (var classUid in this.state.classStates){
            if (this.state.classStates.hasOwnProperty(classUid)) {
                if (this.state.classStates[classUid].selected == true &&
                    this.state.classStates[classUid].students.length == 0) {
                    $totalClass.push(classUid);
                } else if (this.state.classStates[classUid].students != undefined &&
                    this.state.classStates[classUid].students != null &&
                    this.state.classStates[classUid].students.length > 0){
                    $studentsOnly = $studentsOnly.concat(this.state.classStates[classUid].students);
                }
            }
        }

        return AssignmentService.duplicateLibraryAssignment(
                this.props.information.homeworkID , $homeworkName, $toDate, $fromDate, $isRepeatable, 
                $totalClass, $studentsOnly, $comment, this.props.information.languageID).then(function(response) {
                var homeWorkUid = response.homework;
                return homeWorkUid;
            });
    }

}


export default {
    name: function() {return Translation.get(2439 ,'Assign Library Assignment')},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    },
    component: Comfirmation
}